// Business details shared across the site. Edit them here, not in pages.

// Production URL, used for absolute links (sitemap.xml, robots.txt).
export const siteUrl = "https://regradeit.com";

export const site = {
  name: "REGRADEIT",
  email: "support@regradeit.com",
  // WhatsApp only (not for calls). Links stay hidden if `whatsappDigits` is empty.
  whatsapp: "+1 (917) 892-1582",
  whatsappDigits: "19178921582", // country code + number
  hours: "Mon – Fri, 9am – 6pm",
  // State or city only (the owner doesn't want the borough named), or null to hide it.
  // The workshop address is shared with partners after they get in touch.
  location: "New York" as string | null,
  monthlyVolume: 30_000,
  // Capacity, in phones.
  polishPerDay: 4_000,
  paintPerWeek: 3_000,
  minimumBatch: 100 as number | null,

  // Reads after "within": "Most orders are back within a few days to a week, ...".
  turnaround: "a few days to a week, depending on order size" as string | null,
} as const;

export function whatsappHref(text?: string) {
  if (!site.whatsappDigits) return undefined;
  const query = text ? `?text=${encodeURIComponent(text)}` : "";
  return `https://wa.me/${site.whatsappDigits}${query}`;
}

export function mailtoHref(subject?: string, body?: string) {
  const params = new URLSearchParams();
  if (subject) params.set("subject", subject);
  if (body) params.set("body", body);
  const query = params.toString().replace(/\+/g, "%20");
  return `mailto:${site.email}${query ? `?${query}` : ""}`;
}

export const navLinks = [
  { href: "/", label: "Home" },
  { href: "/services", label: "Services" },
  { href: "/gallery", label: "Gallery" },
  { href: "/faq", label: "FAQ" },
  { href: "/contact", label: "Contact" },
];
